import React, { useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import classNames from "classnames";

const RemarkModal = ({
    show,
    onHide,
    title = "Add Remark",
    onSubmit,
    loading = false,
    placeholder = "Enter remark...",
    maxLength = 250,
    submitText = "Submit",
    cancelText = "Cancel",
}) => {
    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm({
        defaultValues: {
            remark: "",
        },
    });

    useEffect(() => {
        if (!show) {
            reset();
        }
    }, [show, reset]);

    const submitHandler = (data) => {
        onSubmit(data.remark);
        reset();
    };

    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <Form.Group>
                    <Form.Label>Remark</Form.Label>

                    <Form.Control
                        as="textarea"
                        rows={3}
                        placeholder={placeholder}
                        maxLength={maxLength}
                        className={classNames({
                            "is-invalid": errors?.remark,
                        })}
                        {...register("remark", {
                            required: "Remark is required",
                            maxLength: {
                                value: maxLength,
                                message: `Remark cannot exceed ${maxLength} characters`,
                            },
                            validate: (value) =>
                                value?.trim()?.length > 0 ||
                                "Remark is required",
                        })}
                    />

                    {errors?.remark && (
                        <div className="text-danger mt-1">
                            {errors.remark.message}
                        </div>
                    )}
                </Form.Group>
            </Modal.Body>

            <Modal.Footer>
                <Button
                    variant="secondary"
                    onClick={() => {
                        reset();
                        onHide();
                    }}
                >
                    {cancelText}
                </Button>

                <Button
                    variant="primary"
                    onClick={handleSubmit(submitHandler)}
                    disabled={loading}
                >
                    {loading ? "Please Wait..." : submitText}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default RemarkModal;